import { BPaginationNav } from './pagination-nav'
import { pluginFactory } from '../../utils/plugins'

const PaginationNavPlugin = /*#__PURE__*/ pluginFactory({
  components: { BPaginationNav }
})

export { PaginationNavPlugin, BPaginationNav }
